module.exports = __webpack_public_path__ + "static/img/union.3ec7c9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cards/union.svg
// module id = fx+/
// module chunks = 1